import React, { useEffect, useState } from "react";
import { Table, Card, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./DashboardSalesVPofSales.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';


const product = [
  { day: 'Sunday', workingHours: '10:00 - 18:00' },
  { day: 'Monday', workingHours: '10:00 - 18:00' },
  { day: 'Tuesday', workingHours: '10:00 - 18:00' },
  { day: 'Wednesday', workingHours: '10:00 - 18:00' },
  { day: 'Thursday', workingHours: '10:00 - 18:00' },
  { day: 'Friday', workingHours: '10:00 - 18:00' },
  { day: 'Saturday', workingHours: '10:00 - 18:00' },
];



const tocustomer = [
  {
    customer: 'Johnson',
    receipt: 'RCPT001',
    commissionAmount: 500,
    commissionPercent: '09%',
  },
  {
    customer: 'Emily Joe',
    receipt: 'RCPT002',
    commissionAmount: 570,
    commissionPercent: '09%',
  },
  {
    customer: 'Joseph',
    receipt: 'RCPT003',
    commissionAmount: 750,
    commissionPercent: '09%',
  },
  {
    customer: 'Petric Beene',
    receipt: 'RCPT004',
    commissionAmount: 250,
    commissionPercent: '09%',
  },
  {
    customer: 'Andrison',
    receipt: 'RCPT005',
    commissionAmount: 600,
    commissionPercent: '09%',
  },
  {
    customer: 'Emma Wilson',
    receipt: 'RCPT006',
    commissionAmount: 250,
    commissionPercent: '09%',
  },
];

const DashboardSalesVPofSales = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const [inputs, setInputs] = useState({ id: '', name: '', emp_id: '', join_date: '', dob: '', emp_mobile: '', email: '' });

  const [workinghours, setWorkinghours] = useState([]);


  const [empkeyword, setEmpkeyword] = useState('');
  const [sortempOrder, setSortempOrder] = useState("asc");
  const [employeehistory, setEmployeehistory] = useState([]);
  const [emplinks, setEmplinks] = useState([]);
  const [emptotalrec, setEmptotalrec] = useState(0);
  const [empperpage, setEmpperpage] = useState(10);


  const [ordkeyword, setOrdkeyword] = useState('');
  const [sortordOrder, setSortordOrder] = useState("asc");
  const [employeeorder, setEmployeeorder] = useState([]);
  const [ordlinks, setOrdlinks] = useState([]);
  const [ordtotalrec, setOrdtotalrec] = useState(0);
  const [ordperpage, setOrdperpage] = useState(10);


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const [isMobile, setIsMobile] = useState(false);
  const [prAccordionOpen, setprAccordionOpen] = useState(false);
  const [cpAccordionOpen, setcpAccordionOpen] = useState(false);
  const [emAccordionOpen, setemAccordionOpen] = useState(false);


  const [activeTab, setActiveTab] = useState('Employment');
  const tabHeaderNames = {
    "Employment": "Merchant Employees",
    "Working Hours": "Employee Working Hours",
    "Appointments or Orders": "Employee Appointments and Orders",
    "Commission": "Employee Commission",
  };

  const tabHeadings = {
    "Employment": "Employee Profile",
    "Working Hours": "Employee Profile",
    "Appointments or Orders": "Employee Profile",
    "Commission": "Employee Profile",
  };

  const setGetActiveTab = (key) => {
    setActiveTab(key);
    if (key === 'Employment') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_employee_history', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setEmployeehistory(response.data.data.payment_history.data);
            setEmplinks(response.data.data.payment_history.links);
            setEmptotalrec(response.data.data.payment_history.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    } else if (key === 'Appointments or Orders') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_employee_orders', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setEmployeeorder(response.data.data.data);
            setOrdlinks(response.data.data.links);
            setOrdtotalrec(response.data.data.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    }
  }

  const handleOrdInputChangeauto = (event) => {
    var keyword = event.target.value;
    setOrdkeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', 1);
    formData.append('order_by', sortordOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_employee_orders', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeeorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleOrdSort = () => {
    setLoading(true);
    var ascdesc = sortordOrder === "asc" ? "desc" : "asc";
    setSortordOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', ordkeyword);
    API.post('backoffice_employee_orders', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeeorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  const handleordRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setOrdperpage(perpage);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_employee_orders', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeeorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleOrdPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', page);
    API.post('backoffice_employee_orders', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeeorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  const handleEmpInputChangeauto = (event) => {
    var keyword = event.target.value;
    setEmpkeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', empperpage);
    formData.append('page', 1);
    formData.append('order_by', sortempOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_employee_history', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeehistory(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleEmpSort = () => {
    setLoading(true);
    var ascdesc = sortempOrder === "asc" ? "desc" : "asc";
    setSortempOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', empperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', empkeyword);
    API.post('backoffice_employee_history', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeehistory(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  const handleempRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setEmpperpage(perpage);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_employee_history', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeehistory(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  const handleEmpPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('per_page', empperpage);
    formData.append('page', page);
    API.post('backoffice_employee_history', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeehistory(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };




  const renderTabContent = () => {
    switch (activeTab) {
      case "Employment":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
              <Card.Title className="d-none d-md-block">Employment History:</Card.Title>
              <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0">
                <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                  <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                    <div className="input-group">
                      <div className="input-group-text border-end-0">
                        <img
                          src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                          alt="Search Icon"
                          className="img-fluid"
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Search"
                        value={empkeyword}
                        onChange={handleEmpInputChangeauto}
                      />
                    </div>
                  </div>
                  <button type="button" className="sloti" onClick={handleEmpSort}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                    Sort {sortempOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                  </button>
                </div>
              </div>
            </div>

            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Working Period</th>
                    <th>Merchant name</th>
                    <th>Employee ID</th>
                    <th>Commission ($)</th>
                    <th>Commission %</th>
                  </tr>
                </thead>
                <tbody>
                  {employeehistory.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.date}</td>
                      <td>
                        <Link to={process.env.REACT_APP_BASE_URL + "merchant-subscription/" + item.store_id}>{item.store_name}</Link></td>
                      <td>{item.customers_id}</td>
                      <td>{item.commission}</td>
                      <td className="ref">{item.commission_per}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setemAccordionOpen(!emAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Employment History</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (emAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || emAccordionOpen) && (
              <>
                <div className="d-md-none mb-3 ev-mobilex">
                  {employeehistory.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      {/* Top row: Join date and Active tag */}
                      <div className="mb-3">
                        <div className="joily d-flex"><div className="date">{item.date} -</div> Join Date</div>
                      </div>

                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">

                          <div className="ms-2 fgtrx">
                            <Link to={process.env.REACT_APP_BASE_URL + "merchant-subscription/" + item.store_id}>{item.store_name}</Link>
                          </div>
                        </div>
                        <div className="kayde">${item.commission.toFixed(2)}</div>
                      </div>

                      <div className="row ojuxi">
                        <div className="col-7">
                          <h2>Employee ID</h2>
                          <h3>{item.customers_id}</h3>
                        </div>
                        <div className="col-5">
                          <h2>Commission %</h2>
                          <h3>{item.commission_per}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={empperpage}
                      onChange={handleempRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {emptotalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {emplinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleEmpPageChange(pageNumber);
                                    }
                                  }}
                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Working Hours":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Working Hours</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Day</th>
                    <th>Working Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {workinghours.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.day}</td>
                      <td className="ref">
                        {item.start_am_pm === "" && item.end_am_pm === ""
                          ? "Close"
                          : `${item.start_hr}:${item.start_min} ${item.start_am_pm} - ${item.end_hr}:${item.end_min} ${item.end_am_pm}`
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setprAccordionOpen(!prAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Working Hours</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (prAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || prAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex">
                  {product.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="mb-3">
                        <div className="jox34ily">{item.day}</div>
                      </div>

                      <div className="row ojuxi45">
                        <div className="col-6">
                          <h2>Working Hours:</h2>
                        </div>
                        <div className="col-6">
                          <h3>{item.workingHours}</h3>
                        </div>
                      </div>

                    </div>
                  ))}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Appointments or Orders":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block mb-2">Appointments or Orders:</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Time</th>
                    <th>Customer</th>
                    <th>Merchant</th>

                    <th>Orders/Appointments</th>
                  </tr>
                </thead>
                <tbody>
                  {employeeorder.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.date}</td>
                      <td>{item.time}</td>
                      <td>{item.customer_name}</td>
                      <td>{item.store_user_name}</td>

                      <td className="ref" style={{ cursor: "pointer", textDecorationLine: "underline" }}><Link to={`${process.env.REACT_APP_BASE_URL}custmssmer-receipts/${item.order_id}/${item.user_id}`}>Appointment #{item.order_number}</Link></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-md-none">
              <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                  <div className="input-group">
                    <div className="input-group-text border-end-0">
                      <img
                        src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                        alt="Search Icon"
                        className="img-fluid"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search"
                      value={ordkeyword}
                      onChange={handleOrdInputChangeauto}
                    />
                  </div>
                </div>
                <button type="button" className="sloti" onClick={handleOrdSort}>
                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                  Sort {sortordOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                </button>
              </div>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Appointments or Orders</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex">
                  {employeeorder.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="mb-3">
                        <div className="joxily" style={{ textDecoration: "underline" }} ><Link to={`${process.env.REACT_APP_BASE_URL}custmssmer-receipts/${item.order_id}/${item.user_id}`}>Appointment #{item.order_number}</Link></div>
                      </div>

                      <div className="row ojuxi">
                        <div className="col-6">
                          <h2>Customer</h2>
                          <h3>{item.customer_name}</h3>
                        </div>
                        <div className="col-6">
                          <h2>Merchant</h2>
                          <h3>{item.store_user_name}</h3>
                        </div>
                      </div>
                      <div className="row ojuxi">
                        <div className="col-6">
                          <h2>Date</h2>
                          <h3>{item.date}</h3>
                        </div>
                        <div className="col-6">
                          <h2>Time</h2>
                          <h3>{item.time}</h3>
                        </div>
                      </div>

                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={ordperpage}
                      onChange={handleordRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>


                  {ordtotalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {ordlinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleOrdPageChange(pageNumber);
                                    }
                                  }}

                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}

                </div>
              </>
            )}
          </Card>
        </div>;
      default:
        return null;
    }
  };

  useEffect(() => {
    document.title = `Dashboard-Merchants-profile | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    API.post('backoffice_employee_detail', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInputs(
            {
              id: response.data.data.id,
              name: response.data.data.name,
              emp_id: response.data.data.emp_id,
              join_date: response.data.data.join_date,
              dob: response.data.data.dob,
              emp_mobile: response.data.data.emp_mobile,
              email: response.data.data.email
            });
          setWorkinghours(response.data.data.working_hours);
        }
      }).catch(error => {
        setLoading(false);
      });


    let formData1 = new FormData();
    formData1.append('token', localStorage.getItem("token"));
    formData1.append('id', id);
    formData1.append('per_page', 10);
    formData1.append('page', 1);
    API.post('backoffice_employee_history', formData1)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setEmployeehistory(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });


    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header tabHeaderName={tabHeaderNames[activeTab]} />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <h1>{tabHeadings[activeTab] || "Employment"}</h1>
                    <div className="vnfro shadow-md-none">
                      <div className="d-flex align-items-center gap-3 mb-4 kjuk">
                        {/* Profile Image */}
                        <div className="leki">
                          <img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/elii.png'}
                            alt="Profile"
                            className="img-fluid"
                          />
                        </div>

                        {/* Store Info */}
                        <div className="infea fgfr">
                          <p>Employee Name</p>
                          <h5>{inputs.name}</h5>
                          <div className="ids">ID# {inputs.emp_id}</div>
                          <div className="date">Join Date: {inputs.join_date}</div>

                        </div>

                      </div>

                      {/* Desktop */}
                      <div className="row mt-3 d-none d-md-flex">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <div className="col-5 text-start tatly mb-1">DOB</div>
                            <div className="col-6 latly">{inputs.dob}</div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <div className="col-5 text-start tatly mb-1">Phone Number</div>
                            <div className="col-6 latly">{inputs.emp_mobile}</div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <div className="col-5 text-start tatly mb-1">Email</div>
                            <div className="col-6 latly">{inputs.email}</div>
                          </div>
                        </div>
                      </div>

                      {/* Mobile */}
                      <div className="row mt-3 d-md-none">
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Phone Number</div>
                          <div className="latly">{inputs.emp_mobile}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Email</div>
                          <div className="latly">{inputs.email}</div>
                        </div>


                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">DOB</div>
                          <div className="latly">{inputs.dob}</div>
                        </div>
                      </div>

                      {/* Footer Tabs (Nav Tabs Style) */}
                      <ul className="nav nav-tabs mt-4 d-none d-md-flex gap-2">
                        {[
                          // { key: "List of Employees", label: "List of Employees" },
                          { key: "Employment", label: "Employment" },
                          { key: "Working Hours", label: "Working Hours" },
                          { key: "Appointments or Orders", label: "Appointments or Orders" },
                        ].map((tab) => (
                          <li className="nav-item" key={tab.key}>
                            <button
                              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                              onClick={() => setGetActiveTab(tab.key)}
                            >
                              {tab.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* Footer Monile (Nav Tabs Style) */}
                      <div className="d-md-none overflow-auto mt-4">
                        <ul className="nav nav-tabs flex-nowrap text-nowrap">
                          {[
                            // { key: "List of Employees", label: "List of Employees" },
                            { key: "Employment", label: "Employment" },
                            { key: "Working Hours", label: "Working Hours" },
                            { key: "Appointments or Orders", label: "Appointments or Orders" },
                          ].map((tab) => (
                            <li className="nav-item" key={tab.key}>
                              <button
                                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                                onClick={() => setActiveTab(tab.key)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 gytf">{renderTabContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal centered show={show} onHide={handleClose} className="ps-0">
        <Modal.Body className="p-0">
          <Col md={12} xs={12}>
            <div className="col-12 holisti">
              <Card className="h-100">
                <div className="table-ro">
                  <Table
                    responsive
                    className="table-no-last-border mb-0"
                  >
                    <thead className="table">
                      <tr className="custom-header">
                        <th className="lft">Customer ID</th>
                        <th>Receipt #</th>
                        <th>Commission ($)</th>
                        <th>Commission %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tocustomer.map((item, index) => (
                        <tr key={index}>
                          <td><Link to={process.env.REACT_APP_BASE_URL + "dashboard-customer2"}>{item.customer}</Link></td>
                          <td><Link to={process.env.REACT_APP_BASE_URL + "custmssmer-receipts"}>{item.receipt}</Link></td>
                          <td>{item.commissionAmount}</td>
                          <td className="ref">{item.commissionPercent}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card>
            </div>
          </Col>
        </Modal.Body>
      </Modal>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default DashboardSalesVPofSales;